<div class="p-grid">
	<div class="p-col-12">
		<span class="p-float-label mt-4">
			<p-dropdown
				#defaultScheduleStartDateSelect
				[options]="app.references.daysOfWeek"
				optionLabel="label"
				optionValue="value"
				name="defaultScheduleStartDateSelect"
				[(ngModel)]="laborSetup.defaultScheduleStartDay"
				[style]="{ width: '100%' }"
				appendTo="body"
				[autoDisplayFirst]="false"
				[virtualScroll]="true"
				itemSize="30"
				filter="true"
				(ngModelChange)="changesToSave()"
				(filterBy)="app.keys(app.references.daysOfWeek)"
			></p-dropdown>
			<label for="defaultScheduleStartDateSelect">First day of schedule week</label>
		</span>
	</div>
</div>
<div class="p-grid mt-4">
	<div class="p-col-12">
		<p-divider>
			<div class="display-12">Weekly Overtime</div>
		</p-divider>
		<small class="text-italics">
			Weekly overtime occurs when an employee works more than a defined number of hours in a week. The employee is then paid a multiple of their payrate
			for hours worked over the defined quantity. All States in the US are subject to Weekly Overtime. But the hour threshold may differ:
			<a href="https://www.wrapbook.com/blog/complete-list-overtime-laws-by-state" target="_blank">Wrapbook Complete List of Overtime Laws by State</a>
		</small>
	</div>
	<div class="p-col-12 p-sm-6 d-flex flex-column">
		<div class="my-auto p-grid">
			<div class="p-col-6">
				<div class="my-auto">Weekly Overtime Enforced</div>
			</div>
			<div class="p-col-6">
				<div class="my-auto">
					<p-inputSwitch [(ngModel)]="laborSetup.weeklyOvertime" styleClass="my-auto" (ngModelChange)="changesToSave()"></p-inputSwitch>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-sm-6 d-flex flex-column">
		<div class="my-auto w-100">
			<div class="ms-auto mt-2">
				<span class="p-float-label mt-4 w-100">
					<p-inputNumber
						#weeklyOvertimeHoursInput
						[(ngModel)]="laborSetup.weeklyOvertimeHours"
						suffix=" hrs"
						inputStyleClass="text-right"
						styleClass="w-100"
						(ngModelChange)="changesToSave()"
						[disabled]="!laborSetup.weeklyOvertime"
					></p-inputNumber>
					<label for="weeklyOvertimeHoursInput">Weekly Overtime Hours Threshold</label>
				</span>
			</div>
			<div class="ms-auto">
				<span class="p-float-label mt-4 w-100">
					<p-inputNumber
						#weeklyOvertimeRateInput
						[(ngModel)]="laborSetup.weeklyOvertimeRate"
						suffix="x"
						minFractionDigits="1"
						maxFractionDigits="1"
						inputStyleClass="text-right"
						styleClass="w-100"
						(ngModelChange)="changesToSave()"
						[disabled]="!laborSetup.weeklyOvertime"
					></p-inputNumber>
					<label for="weeklyOvertimeRateInput">Weekly Overtime Pay Rate Multiplier</label>
				</span>
			</div>
		</div>
	</div>
</div>
<div class="p-grid mt-4">
	<div class="p-col-12">
		<p-divider>
			<div class="display-12">Daily Overtime</div>
		</p-divider>
		<small class="text-italics">
			Daily overtime occurs when an employee works more than a certain amount of hours in a day. The employee is then entitled to a multiple of their pay.
			See if your state requires Daily Overtime:
			<a href="https://www.wrapbook.com/blog/complete-list-overtime-laws-by-state" target="_blank">Wrapbook Complete List of Overtime Laws by State</a>
		</small>
	</div>
	<div class="p-col-12 p-sm-6">
		<div class="my-auto p-grid">
			<div class="p-col-6">
				<div class="my-auto">Daily Overtime Enforced</div>
			</div>
			<div class="p-col-6">
				<div class="my-auto">
					<p-inputSwitch [(ngModel)]="laborSetup.dailyOvertime" styleClass="my-auto" (ngModelChange)="changesToSave()"></p-inputSwitch>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-sm-6 d-flex flex-column">
		<div class="my-auto w-100">
			<div class="ms-auto mt-2">
				<span class="p-float-label mt-4 w-100">
					<p-inputNumber
						#dailyOvertimeHoursInput
						[(ngModel)]="laborSetup.dailyOvertimeHours"
						suffix=" hrs"
						inputStyleClass="text-right"
						styleClass="w-100"
						(ngModelChange)="changesToSave()"
						[disabled]="!laborSetup.dailyOvertime"
					></p-inputNumber>
					<label for="dailyOvertimeHoursInput">Daily Overtime Hours Threshold</label>
				</span>
			</div>
			<div class="ms-auto">
				<span class="p-float-label mt-4 w-100">
					<p-inputNumber
						#dailyOvertimeRateInput
						[(ngModel)]="laborSetup.dailyOvertimeRate"
						suffix="x"
						minFractionDigits="1"
						maxFractionDigits="1"
						inputStyleClass="text-right"
						styleClass="w-100"
						(ngModelChange)="changesToSave()"
						[disabled]="!laborSetup.dailyOvertime"
					></p-inputNumber>
					<label for="dailyOvertimeRateInput">Daily Overtime Pay Rate Multiplier</label>
				</span>
			</div>
		</div>
	</div>
</div>
<div class="p-grid mt-4">
	<div class="p-col-12">
		<p-divider>
			<div class="display-12">Daily Double Overtime</div>
		</p-divider>
		<small class="text-italics">
			Daily Double time is when an employee works beyond a certain number of hours in a day and thus is paid twice their normal rate of pay. As of
			October, 2022, only California has Daily Double Overtime. See if your State now enforces Daily Double Overtime:
			<a href="https://www.wrapbook.com/blog/complete-list-overtime-laws-by-state" target="_blank">Wrapbook Complete List of Overtime Laws by State</a>
		</small>
	</div>
	<div class="p-col-12 p-sm-6 d-flex flex-column">
		<div class="my-auto p-grid">
			<div class="p-col-6">
				<div class="my-auto">Daily Double Overtime Enforced</div>
			</div>
			<div class="p-col-6">
				<div class="my-auto">
					<p-inputSwitch [(ngModel)]="laborSetup.dailyDoubleOvertime" styleClass="my-auto" (ngModelChange)="changesToSave()"></p-inputSwitch>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-sm-6 d-flex flex-column">
		<div class="my-auto w-100">
			<div class="ms-auto mt-2">
				<span class="p-float-label mt-4 w-100">
					<p-inputNumber
						#dailyOvertimeHoursInput
						[(ngModel)]="laborSetup.dailyDoubleOvertimeHours"
						suffix=" hrs"
						styleClass="w-100"
						inputStyleClass="text-right"
						(ngModelChange)="changesToSave()"
						[disabled]="!laborSetup.dailyDoubleOvertime"
					></p-inputNumber>
					<label for="dailyOvertimeHoursInput">Daily Double Overtime Hours Threshold</label>
				</span>
			</div>
			<div class="ms-auto mt-2">
				<span class="p-float-label mt-4">
					<p-inputNumber
						#dailyOvertimeRateInput
						[(ngModel)]="laborSetup.dailyDoubleOvertimeRate"
						suffix="x"
						minFractionDigits="1"
						maxFractionDigits="1"
						inputStyleClass="text-right"
						styleClass="w-100"
						(ngModelChange)="changesToSave()"
						[disabled]="!laborSetup.dailyDoubleOvertime"
					></p-inputNumber>
					<label for="dailyOvertimeRateInput">Daily Double Overtime Pay Rate Multiplier</label>
				</span>
			</div>
		</div>
	</div>
</div>
<div class="p-grid mt-4">
	<div class="p-col-12">
		<p-divider>
			<div class="display-12">Sixth Day Overtime</div>
		</p-divider>
		<small class="text-italics">
			Daily Double time is when an employee works beyond a certain number of hours in a day and thus is paid twice their normal rate of pay. As of
			October, 2022, only California has Daily Double Overtime. See if your State now enforces Daily Double Overtime:
			<a href="https://www.wrapbook.com/blog/complete-list-overtime-laws-by-state" target="_blank">Wrapbook Complete List of Overtime Laws by State</a>
		</small>
	</div>
	<div class="p-col-12 p-sm-6 d-flex flex-column">
		<div class="my-auto p-grid">
			<div class="p-col-6">
				<div class="my-auto">Sixth Day Overtime</div>
			</div>
			<div class="p-col-6">
				<div class="my-auto">
					<p-inputSwitch [(ngModel)]="laborSetup.sixthDayOvertime" styleClass="my-auto" (ngModelChange)="changesToSave()"></p-inputSwitch>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-sm-6 d-flex flex-column">
		<div class="my-auto w-100">
			<div class="ms-auto">
				<span class="p-float-label mt-4">
					<p-inputNumber
						#sixthOvertimeRateInput
						[(ngModel)]="laborSetup.sixthDayOvertimeRate"
						suffix="x"
						minFractionDigits="1"
						maxFractionDigits="1"
						inputStyleClass="text-right"
						styleClass="w-100"
						(ngModelChange)="changesToSave()"
						[disabled]="!laborSetup.sixthDayOvertime"
					></p-inputNumber>
					<label for="sixthOvertimeRateInput">Sixth Day Pay Rate Multiplier</label>
				</span>
			</div>
		</div>
	</div>
</div>
<div class="p-grid mt-4">
	<div class="p-col-12">
		<p-divider>
			<div class="display-12">Seventh Day Overtime</div>
		</p-divider>
		<small class="text-italics">
			Daily Double time is when an employee works beyond a certain number of hours in a day and thus is paid twice their normal rate of pay. As of
			October, 2022, only California has Daily Double Overtime. See if your State now enforces Daily Double Overtime:
			<a href="https://www.wrapbook.com/blog/complete-list-overtime-laws-by-state" target="_blank">Wrapbook Complete List of Overtime Laws by State</a>
		</small>
	</div>
	<div class="p-col-12 p-sm-6 d-flex flex-column">
		<div class="my-auto p-grid">
			<div class="p-col-6">
				<div class="my-auto">Seventh Day Overtime</div>
			</div>
			<div class="p-col-6">
				<div class="my-auto">
					<p-inputSwitch [(ngModel)]="laborSetup.seventhDayOvertime" styleClass="my-auto" (ngModelChange)="changesToSave()"></p-inputSwitch>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-sm-6 d-flex flex-column">
		<div class="my-auto w-100">
			<div class="ms-auto">
				<span class="p-float-label mt-4">
					<p-inputNumber
						#sixthOvertimeRateInput
						[(ngModel)]="laborSetup.seventhDayOvertimeRate"
						suffix="x"
						minFractionDigits="1"
						maxFractionDigits="1"
						inputStyleClass="text-right"
						styleClass="w-100"
						(ngModelChange)="changesToSave()"
						[disabled]="!laborSetup.seventhDayOvertime"
					></p-inputNumber>
					<label for="sixthOvertimeRateInput">Seventh Day Pay Rate Multiplier</label>
				</span>
			</div>
		</div>
	</div>
</div>
